import React from 'react';
import { ui } from './ui';
import { TYPE_LABEL } from './aiPaperUtils';

const area = { ...ui.input, resize: 'vertical', minHeight: 44, fontFamily: "'Noto Serif Devanagari','Noto Serif','Nirmala UI',serif", lineHeight: 1.4 };

const Txt = ({ value, onChange, placeholder, rows = 2 }) => (
  <textarea style={area} rows={rows} value={value ?? ''} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />
);

// One editable question card. Defined at module level so typing never remounts it.
function QuestionEditor({
  q, no, mode, isFirst, isLast, busy, onChange, onOptionChange, onMove, onRegenerate, onDelete
}) {
  const showEn = mode !== 'hindi';
  const showHi = mode !== 'english';
  return (
    <div style={{ border: '1px solid #c7d2fe', borderRadius: 10, padding: 10, marginBottom: 10, background: '#fff', opacity: busy ? 0.6 : 1 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6, flexWrap: 'wrap' }}>
        <b style={{ color: '#3730a3' }}>Q{no}</b>
        <span style={{ fontSize: 11, background: '#eef2ff', color: '#4338ca', padding: '2px 8px', borderRadius: 10, fontWeight: 700 }}>{TYPE_LABEL[q.type]}</span>
        {q.pageRef ? <span style={{ fontSize: 11, color: '#64748b' }}>p. {q.pageRef}</span> : null}
        <span style={{ flex: 1 }} />
        <label style={{ fontSize: 12, fontWeight: 700 }}>Marks</label>
        <input type="number" min={0} step={0.5} style={{ ...ui.input, width: 64, padding: '4px 6px' }}
          value={q.marks} onChange={(e) => onChange(q.qId, 'marks', e.target.value === '' ? '' : Number(e.target.value))} />
        <button style={ui.btnSmall} disabled={isFirst} onClick={() => onMove(q.qId, -1)} title="Move up">▲</button>
        <button style={ui.btnSmall} disabled={isLast} onClick={() => onMove(q.qId, 1)} title="Move down">▼</button>
        <button style={ui.btnSmall} disabled={busy} onClick={() => onRegenerate(q.qId)} title="Regenerate this question from the same PDF">
          {busy ? '…' : '🔄 Regenerate'}
        </button>
        <button style={{ ...ui.btnSmall, color: '#b91c1c' }} onClick={() => onDelete(q.qId)} title="Delete question">🗑</button>
      </div>
      {showEn && <Txt value={q.textEnglish} onChange={(v) => onChange(q.qId, 'textEnglish', v)} placeholder="Question (English)" />}
      {showHi && <div style={{ marginTop: showEn ? 6 : 0 }}><Txt value={q.textHindi} onChange={(v) => onChange(q.qId, 'textHindi', v)} placeholder="प्रश्न (हिंदी)" /></div>}
      {q.type === 'MCQ' && (
        <div style={{ marginTop: 8, display: 'grid', gap: 6 }}>
          {q.options.map((o, i) => (
            <div key={o.label} style={{ display: 'flex', gap: 6, alignItems: 'flex-start' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 3, fontWeight: 800, fontSize: 13, paddingTop: 8, cursor: 'pointer' }}>
                <input type="radio" name={`ans-${q.qId}`} checked={q.correctAnswer === o.label} onChange={() => onChange(q.qId, 'correctAnswer', o.label)} />
                {o.label}
              </label>
              <div style={{ flex: 1, display: 'grid', gridTemplateColumns: showEn && showHi ? '1fr 1fr' : '1fr', gap: 6 }}>
                {showEn && <input style={ui.input} value={o.textEnglish ?? ''} placeholder="Option (English)" onChange={(e) => onOptionChange(q.qId, i, 'textEnglish', e.target.value)} />}
                {showHi && <input style={ui.input} value={o.textHindi ?? ''} placeholder="विकल्प (हिंदी)" onChange={(e) => onOptionChange(q.qId, i, 'textHindi', e.target.value)} />}
              </div>
            </div>
          ))}
        </div>
      )}
      {q.type !== 'MCQ' && (
        <div style={{ marginTop: 6, display: 'grid', gap: 6 }}>
          <input style={ui.input} value={q.correctAnswer ?? ''} placeholder="Correct answer (key)" onChange={(e) => onChange(q.qId, 'correctAnswer', e.target.value)} />
        </div>
      )}
      <details style={{ marginTop: 6 }}>
        <summary style={{ fontSize: 12, fontWeight: 700, color: '#475569', cursor: 'pointer' }}>Marking scheme / model answer (teacher key only)</summary>
        <div style={{ marginTop: 4 }}><Txt rows={3} value={q.modelAnswer} onChange={(v) => onChange(q.qId, 'modelAnswer', v)} placeholder="One marking point per line" /></div>
      </details>
    </div>
  );
}

export default React.memo(QuestionEditor);
